<app-uni-page [parent]="this" pageTitle="Job Order - Invoices" [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="qb-child-actions shrink-0">
          <span class="font-semibold">Invoices</span>
          <div class="flex items-center gap-2">
            <button pButton type="button" class="p-button-raised p-button-sm" [disabled]="!canUndoInvoice(invoiceHeader)"
              (click)="undoInvoice(invoiceHeader)">
              Undo Invoice
            </button>
            <button *ngIf="invoiceHeader != null" pButton type="button" class="p-button-raised p-button-sm" (click)="goPrintableInvoice()">
              <span>Print Preview</span>
            </button>
          </div>
        </div>
        <div class="shrink-0" style="height: 95px">
          <app-ag-grid [gridOptions]="johGridOptions" [rowData]="joHeaders"></app-ag-grid>
        </div>

        <app-ag-grid [gridOptions]="invhGridOptions" [rowData]="invoiceHeaders" class="flex-1 min-h-0"></app-ag-grid>
      </div>
    </ng-template>

    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full">
        <p-tabView *ngIf="invoiceHeader" (onChange)="onTabChanged($event)" class="h-full w-full uni-tabview"
          styleclass="h-full">
        <p-tabPanel header="Info">
          <div uni-flex-col>
            <div uni-flex-row>
              <uni-field label="Invoice #">
                <input pInputText [ngModel]="invoiceHeader.id" disabled />
              </uni-field>
              <uni-field label="Invoice Date">
                <input pInputText [ngModel]="invoiceHeader.invoiceDate | date : 'MM/dd/yyyy'" disabled />
              </uni-field>
              <uni-field label="Due Date">
                <input pInputText [ngModel]="invoiceHeader.dueDate | date : 'MM/dd/yyyy'" disabled />
              </uni-field>
            </div>
            <div uni-flex-row>
              <uni-field label="Status">
                <input pInputText [ngModel]="
                    dbLookup('InvoiceStatus', invoiceHeader.invoiceStatusId)
                  " disabled />
              </uni-field>
              <uni-field label="Job Order">
                <input pInputText [ngModel]="invoiceHeader.joHeaderId" disabled />
              </uni-field>
            </div>
            <div uni-flex-row>
              <uni-field label="Extended Amt">
                <input pInputText [ngModel]="invoiceHeader.calcExtendedAmt() | currency" disabled />
              </uni-field>
              <uni-field label="Extended Reissue Amt">
                <input pInputText [ngModel]="invoiceHeader.calcExtendedReissueAmt() | currency" disabled />
              </uni-field>
              <uni-field label="Tax Rate">
                <input pInputText [ngModel]="joHeaders[0].taxRate" disabled />
              </uni-field>
              <uni-field label="Tax Amt">
                <input pInputText [ngModel]="invoiceHeader.taxAmt || 0 | currency" disabled />
              </uni-field>
            </div>
            <div uni-flex-row>
              <ng-container *ngIf="invoiceHeader.wasMigrated; else notMigrated">
                <uni-field label="Freight">
                  <input pInputText [ngModel]="invoiceHeader.freightAmt | currency" disabled />
                </uni-field>
              </ng-container>
              <ng-template #notMigrated>
                <uni-field *ngIf="
                    invoiceHeader.isPrimaryInvoice && invoiceHeader?.shipment
                  " label="Freight">
                  <input pInputText [ngModel]="invoiceHeader.calcShipFreightAmt() | currency" disabled />
                </uni-field>
              </ng-template>
              <uni-field label="Handling">
                <input pInputText [ngModel]="invoiceHeader.orderHandlingAmt || 0 | currency" disabled />
              </uni-field>
              <uni-field label="Prepaid">
                <input pInputText [ngModel]="
                    '(' + (invoiceHeader.prepaymentAmt || 0 | currency) + ')'
                  " disabled />
              </uni-field>
              <uni-field *ngIf="invoiceHeader.pCardAmt" label="Paid ({{ getPcardName(invoiceHeader) }})">
                <input pInputText [ngModel]="
                    '(' + (invoiceHeader.pCardAmt || 0 | currency) + ')'
                  " disabled />
              </uni-field>
              <uni-field *ngIf="invoiceHeader.pCardTransactionId" label="P-Card Transaction">
                <input pInputText [ngModel]="invoiceHeader.pCardTransactionId" disabled />
              </uni-field>
              <uni-field label="Total">
                <input pInputText [ngModel]="invoiceHeader.calcTotalAmt() | currency" disabled />
              </uni-field>
              <uni-field *ngIf="shouldShowMigratedTotal(invoiceHeader)" label="Migrated Total">
                <input pInputText [ngModel]="invoiceHeader.totalAmt | currency" disabled />
              </uni-field>
            </div>
            <div uni-flex-row>
              <div>
                {{ invoiceHeader.shipFreightInfo }}
              </div>
            </div>
            <div uni-flex-row *ngIf="canDisplayAltVoucherMessage()">
              <div>
                <b>Note: There are
                  {{ this.vouchersWithSameAddress?.length }} other voucher(s)
                  for this same account/address that are not on this shipment.
                </b>
              </div>
            </div>
            <div uni-flex-row *ngIf="invoiceHeader?.invoiceStatusId === 'POSTED'">
              <div>
                <a class="text-primary" href="{{ getQuickbooksLink(invoiceHeader) }}" target="_blank">See invoice {{
                  invoiceHeader.id }} in QuickBooks</a>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Bill To">
          <div>
            <app-address-component [entity]="invoiceHeader.joHeader" [prefix]="'billing'" [isReadonly]="true">
            </app-address-component>
            <button [disabled]="!canEditAddress('billing')" pButton type="button" class="p-button-raised"
              (click)="editAddress('billing', 'Billing')">
              Edit Address
            </button>
          </div>
        </p-tabPanel>
        <p-tabPanel *ngIf="!joHeader.isAccountOwnedOrder" header="Ship To">
          <ng-template pTemplate="content">
            <div>
              <app-address-component [entity]="invoiceHeader.joHeader" [prefix]="'shipping'"></app-address-component>
              <button [disabled]="!canEditAddress('shipping')" pButton type="button" class="p-button-raised"
                (click)="editAddress('shipping', 'Shipping')">
                Edit Address
              </button>
            </div>
          </ng-template>
        </p-tabPanel>
        <p-tabPanel header="Invoice Details">
          <app-ag-grid [gridOptions]="invdGridOptions" [rowData]="invoiceDetails"></app-ag-grid>
        </p-tabPanel>
        <!-- Removed per discussion with Jeff - 4/2x/2020 -->
        <!-- <p-tabPanel header="Job Order Details" id="group">
            <ng-template pTemplate="content">
              <app-ag-grid [gridOptions]="jodGridOptions" [rowData]="joDetails" ></app-ag-grid>  
            </ng-template>
          </p-tabPanel> -->
        <p-tabPanel header="Item Details">
          <app-ag-grid [gridOptions]="itdGridOptions" [rowData]="itemDetails"></app-ag-grid>
        </p-tabPanel>
        <p-tabPanel *ngIf="!invoiceHeader?.wasMigrated && invoiceHeader?.isPrimaryInvoice" header="Freight">
          <div uni-flex-row>
            <uni-field label="Carrier">
              <input pInputText [ngModel]="getCarrierDisplayName(invoiceHeader)" disabled />
            </uni-field>
            <uni-field label="Service" style="width: 250px">
              <input pInputText [ngModel]="getServiceDisplayName(invoiceHeader)" disabled />
            </uni-field>
            <uni-field label="ShipEngine Shipment Id">
              <input pInputText [ngModel]="invoiceHeader.shipment.shipmentApiIdentifier" disabled />
            </uni-field>
            <!-- <uni-field label="Unit of Measure">
                  <input pInputText [value]= "uomMap[invoiceHeader.shipment.weightUoMId]" disabled />
                </uni-field> -->
          </div>
          <div uni-flex-row>
            <uni-field *ngIf="
                invoiceHeader.shipment.primaryInvoiceHeaderId ==
                invoiceHeader.id
              " label="Freight">
              <input pInputText [ngModel]="invoiceHeader.shipment.freightAmt | currency" disabled />
            </uni-field>
            <uni-field *ngIf="
                invoiceHeader.shipment.primaryInvoiceHeaderId !=
                invoiceHeader.id
              " label="Freight">
              <input pInputText [ngModel]="
                  'On invoice: ' + invoiceHeader.shipment.primaryInvoiceHeaderId
                " disabled />
            </uni-field>

            <uni-field label="Handling">
              <input pInputText [ngModel]="invoiceHeader.orderHandlingAmt || 0 | currency" disabled />
            </uni-field>
          </div>
          <div uni-flex-row>
            <div>
              {{ invoiceHeader.shipFreightInfo }}
            </div>
          </div>
          <app-ag-grid [gridOptions]="sboxGridOptions" [rowData]="shippingBoxes"></app-ag-grid>
          <ng-template #shipLabelCell let-box>
            <button *ngIf="!!box.shippingLabel" (click)="printBoxLabel(box)">
              Print Label
            </button>
          </ng-template>
        </p-tabPanel>
      </p-tabView>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>